<template>
  <transition name="modal" >
    <div class="down-app">
      <div class="left">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-H5xiazailogo"></use>
        </svg>
        <div>
          <!--下载 SuperEx APP-->
          <p class="content">{{$t('300029')}}</p>
          <!--随时随地交易-->
          <p class="tip">{{$t('300030')}}</p>
        </div>
      </div>
      <div class="right">
        <svg slot="image" class="icon" aria-hidden="true" @click="$router.push('/download')">
          <use xlink:href="#icon-xiazaitubiao"></use>
        </svg>
        <i class="iconfont icon-H5xiazaiguanbi" @click="close"></i>
      </div>
    </div>
  </transition>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: "appDown",
        data() {
            return {
                domain: ''
            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        methods: {
            close() {
                this.$emit('close')
            },
        }
    }
</script>

<style lang="scss" scoped>
  @import "../style/mixin";
  @import "../assets/css/variableName";

  .down-app {
    position: fixed;
    bottom: torem(12);
    width: 90%;
    height: torem(60);
    box-sizing: border-box;
    padding: 0 torem(16) 0 torem(24);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: torem(6);
    background: rgba(30, 33, 39, 0.9);
    z-index: 1;
    left: 5%;
    .left{
      display: flex;
      align-items: center;
      svg{
        @include wh(torem(36),torem(36));
        margin-right: torem(8);
      }
      p.content{
        @include sc(torem(15),#FFFFFF);
        margin-bottom: torem(4);
      }
      p.tip{
        @include sc(torem(11),#999999);
      }
    }
    .right{
      display: flex;
      align-items: center;
      svg{
        @include wh(torem(32),torem(32));
        margin-right: torem(8);
      }
      i{
        @include sc(torem(14),rgba(255, 255, 255, 0.15));
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/compontents/appDown.vue